export default __webpack_public_path__ + "static/media/stuart_lilac.178b0281.jpg";